import PropTypes from 'prop-types';

export default PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    editable: PropTypes.func.isRequired,
    type: PropTypes.oneOf(['select', 'text', 'number', 'date', 'image', 'textarea', 'textfile']),
    values: PropTypes.arrayOf(PropTypes.string),
    columnName: PropTypes.string.isRequired
  })
).isRequired;
